export default __webpack_public_path__ + "assets/images/3e665d45a702cfbb1f0125fd12a7158e.mp3";